import { createTheme } from "@mui/material/styles";
import { BRAND, NEUTRAL, SEMANTIC, FONT } from "./brand";

const corebaseTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: BRAND.bright, dark: "#0250B3", light: "#4A8FEA", contrastText: BRAND.white },
    secondary: { main: BRAND.sky, dark: "#3A76A3", light: BRAND.light, contrastText: BRAND.white },
    info: { main: BRAND.sky, dark: "#3A76A3", light: BRAND.light, contrastText: BRAND.white },
    success: { main: SEMANTIC.revenue, dark: "#166B44", light: "#4CB482", contrastText: BRAND.white },
    warning: { main: SEMANTIC.warning, dark: "#9A5C00", light: "#F0B04F", contrastText: BRAND.white },
    error: { main: SEMANTIC.danger, dark: "#A12A2A", light: "#E57373", contrastText: BRAND.white },
    navy: { main: BRAND.navy, dark: "#081829", light: "#1F3B5E", contrastText: BRAND.white },
    tint: {
      revenue: SEMANTIC.revenueTint,
      pipeline: SEMANTIC.pipelineTint,
      potential: SEMANTIC.potentialTint,
      warning: SEMANTIC.warningTint,
      danger: SEMANTIC.dangerTint,
      neutral: SEMANTIC.neutralTint,
    },
    favorite: { main: "#F2B01E" },
    text: { primary: NEUTRAL.text, secondary: NEUTRAL.textSecondary, disabled: "rgba(14, 37, 64, 0.38)" },
    background: { default: NEUTRAL.background, paper: BRAND.white },
    divider: NEUTRAL.border,
    action: {
      hover: "rgba(3, 102, 225, 0.06)",
      selected: "rgba(3, 102, 225, 0.10)",
      focus: "rgba(3, 102, 225, 0.14)",
    },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: FONT.body,
    fontSize: 14,
    h4: { fontFamily: FONT.title, fontWeight: 900, letterSpacing: "0.05em" },
    h5: { fontFamily: FONT.title, fontWeight: 800, letterSpacing: "0.04em" },
    h6: { fontFamily: FONT.subtitle, fontWeight: 600, fontSize: "1rem", letterSpacing: "0.06em" },
    subtitle1: { fontFamily: FONT.subtitle, fontWeight: 600, letterSpacing: "0.04em" },
    subtitle2: { fontFamily: FONT.subtitle, fontWeight: 600, letterSpacing: "0.04em" },
    body1: { letterSpacing: "0.02em" },
    body2: { letterSpacing: "0.02em" },
    caption: { fontFamily: FONT.detail, letterSpacing: "0.02em" },
    overline: { fontFamily: FONT.subtitle, fontWeight: 600, letterSpacing: "0.1em", lineHeight: 1.8 },
    button: { fontWeight: 600, letterSpacing: "0.02em", textTransform: "none" },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 10 } },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: { borderColor: NEUTRAL.border },
      },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 12 } },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { height: 3, borderRadius: "3px 3px 0 0" },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          minHeight: 48,
          color: NEUTRAL.textSecondary,
          "&.Mui-selected": { color: BRAND.bright },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontFamily: FONT.detail, fontWeight: 600, letterSpacing: "0.02em" },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: { fontFamily: FONT.title, fontWeight: 700, letterSpacing: "0.02em" },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: BRAND.navy, fontFamily: FONT.detail, fontSize: 12 },
        arrow: { color: BRAND.navy },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, color: BRAND.navy, backgroundColor: NEUTRAL.background },
        root: { borderColor: NEUTRAL.border },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: { root: { borderRadius: 10 } },
    },
    MuiAccordion: {
      styleOverrides: { root: { "&:before": { display: "none" } } },
    },
  },
});

export default corebaseTheme;
